const mutations = {
  
    ADD_FUNCIONARIOS (state, value) {

        state.allalunos.push(value)

    },
    ADD_MATRICULAR_ALUNO (state, value) {

        state.allmatriculaaluno.push(value)

    },
    ALL_ALUNOS (state, value) {

        state.allalunos = value

    },
    ALL_MATRICULA_ALUNO (state, value) {

        state.allmatriculaaluno = value

    },
    SET_ALUNO (state, value) {

        state.get_aluno = value
        state.getAluno = value

    },
    ALL_FATURAS_ALUNO (state, value) {

        state.allfaturasaluno = value

    },
    SET_BUSCAR_ALUNOS (state, value) {

        state.buscar_alunos = value

    },
   
}

export default mutations